
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Etiquetadora } from '@/__env/lib/Sistema/Etiquetadora/Etiquetadora.nav';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import { isString } from 'util';
    import jQuery from 'jquery';
    import print from 'print-js';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        @Prop( { default: [] } )
        public Pedidos: Pedido[];

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            this.$nextTick( () => this.Abierto = true );

        }

        async mounted()
        {
            let e = await Etiquetadora.find( {} );
            this.Etiquetadoras = e.Items;
            if ( this.Etiquetadoras.hasRows() )
            {
                this.Etiquetadora = e.Items[0];
                this.Tipo = this.Tipos[0];
            }

        }


        public Abierto: boolean = false;
        public Cargando: boolean = false;
        public Etiquetadoras: Etiquetadora[] = [];
        public Tipos: { Nombre: string, Id: string; }[] = [
            { Nombre: "ZEBRA CHICA", Id: "item-zebra-chica" }
        ];

        public Tipo: { Nombre: string, Id: string; } = null;
        public Etiquetadora: Etiquetadora = null;

        async Descargar()
        {
            this.Cargando = true;
            let eti = await Pedido.URLEtiquetasItems( this.Pedidos );
            if ( isString( eti ) )
            {
                print( 'eti' );

            } else
            {
                Utiles.Notificaciones.Error( `Error al generar las etiquetas` );

            }
            this.Cargando = false;
        }


        async Imprimir()
        {
            this.Cargando = true;
            let pdf = await Pedido.URLEtiquetasItems( this.Pedidos, this.Etiquetadora.Id );
            if ( pdf )
            {
                await Wait( 5000 );
                this.Cargando = false;
                this.Abierto = false;
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar las etiquetas` );

            }
            this.Cargando = false;

        }

        Cerrar()
        {
            this.Cargando = false;
            this.Abierto = false;
        }

    }
